// extracted by mini-css-extract-plugin
export var active = "_iv-2";
export var recordingDot = "_iv-1";
export var recordingIndicator = "_iv-0";